import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import HeaderDropdown from 'flarum/forum/components/HeaderDropdown';
import classList from 'flarum/common/utils/classList';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class DialogsDropdown extends HeaderDropdown {
  constructor() {
    super(...arguments);
    _defineProperty(this, "DialogDropdownList", null);
  }
  static initAttrs(attrs) {
    attrs.className = classList('DialogsDropdown', attrs.className);
    attrs.label = attrs.label || app.translator.trans('flarum-messages.forum.header.dropdown_tooltip');
    attrs.icon = attrs.icon || 'fas fa-envelope';
    super.initAttrs(attrs);
  }
  getContent() {
    if (!this.DialogDropdownList) {
      import(/* webpackChunkName: 'forum/components/DialogDropdownList', webpackMode: 'lazy-once' */ './DialogDropdownList').then(DialogDropdownList => {
        this.DialogDropdownList = DialogDropdownList.default;
      });
      return m(LoadingIndicator, null);
    }
    return m(this.DialogDropdownList, {
      state: this.attrs.state
    });
  }
  goToRoute() {
    m.route.set(app.route('messages'));
  }
  getUnreadCount() {
    return app.session.user.attribute('messageCount');
  }
  getNewCount() {
    return app.session.user.attribute('messageCount');
  }
}
flarum.reg.add('flarum-messages', 'forum/components/DialogsDropdown', DialogsDropdown);flarum.reg.addChunkModule('619', '331', 'flarum-messages', 'forum/components/DialogDropdownList');
flarum.reg.addChunkModule('619', '331', 'flarum-messages', 'forum/components/DialogList');
flarum.reg.addChunkModule('619', '331', 'flarum-messages', 'forum/components/DialogListItem');